// extracted by mini-css-extract-plugin
export default {"termsWrapper":"Terms_termsWrapper__E0FQM"};